<template>
    <div class="poiList">
        <Evtable :header="tableHeader" :params="paramsUrl"
                 :quickSearchKey="quickSearchKey" :quickSearchReg="quickSearchReg"
                 :quickSearchPlaceholder="quickSearchPlaceholder"
                 searchDialogWidth="50%"
                 :searchRules="searchRules"
                 :searchData="searchDatas"
                 :actionWidth="actionWidth"
                 @tableRefresh="tableRefresh"
                 @refresh="refresh"
                 @select="selectedDatas"
                 @selectAll="selectAll"
                 @currentChange="pageChange"
                 v-loading="pageload"
                 :tools="tools" :actions="action" :url="pageUrl">
            <template slot="append-search"
                      slot-scope="th">
                <div style="float: left;"
                     class="poiSearch">
                    <div style="float: left">
                        <Evcascader ref="type" slot="type" v-model="type" style="width: 120px;"
                                    :options="poiType" :props="props" expandTrigger="hover"  @change="poiTypeChange"
                                    class="searchSelect selectItem"
                                    placeholder="类型" clearable>
                        </Evcascader>
                    </div>
                    <div style="float: left">
                        <Evselect v-model="status"
                                  placeholder="状态"
                                  clearable
                                  class="searchSelect selectItem"
                                  style="width: 120px"
                                  @change="statusChange">
                            <el-option v-for="item in optionss"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </Evselect>
                    </div>
                </div>

            </template>
            <template slot="searchForm">
                <el-col :span="24">
                    <el-form-item label="标题" prop="title" label-width="80px">
                        <el-input maxlength="200" placeholder="请输入标题" v-model.trim="searchDatas.title"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="所属景区" prop="principalId" label-width="80px">
                        <el-select
                                v-model="searchDatas.principalId"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入景区信息"
                                :remote-method="remoteMethod"
                                :loading="loading"
                                @change="clearArray">
                            <el-option
                                    v-for="item in allScenic"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="所在地区" prop="regionFullCode" label-width="80px">
                        <EvareaChoose
                                v-model="searchDatas.regionFullCode.split(',')[searchDatas.regionFullCode.split(',').length-1]"
                                :level="3"
                                resetcode="0"
                                expandTrigger="hover"
                                @onchange="areaCodeChange"
                                placeholder="请输入所在地区"
                                :checkStrictly="true"
                        ></EvareaChoose>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="类型" prop="type" label-width="80px">
                        <Evcascader v-model="searchDatas.type"
                                    :options="poiType" :props="props" expandTrigger="hover"
                                    class="searchSelect selectItem" @change="searchTypeChange"
                                    placeholder="请选择所属类型" clearable>
                        </Evcascader>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="状态" prop="status" label-width="80px">
                        <el-radio-group v-model="searchDatas.status">
                            <el-radio label="1">下线</el-radio>
                            <el-radio label="9">上线</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </template>
            <template slot="tool-button">
                <el-dropdown class="glbqButton" @command="handleCommand" v-if="this.request.checkAuth('commonInfo:bo',th)">
                    <el-tooltip effect="dark" content="批量上下线" placement="top">
                        <el-button type="primary" icon="fa fa-map-signs" size="mini"></el-button>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="9">批量上线</el-dropdown-item>
                        <el-dropdown-item command="1">批量下线</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
        </Evtable>

        <!-- 关联标签弹层 -->
        <el-dialog class="dialog" title="关联标签" :visible.sync="relateTagsModal" width="800px"
                   :before-close="closeRelateTagsModal" :close-on-click-modal="false" ref="clears">
            <cl-form class="dialog-form" :model="relateTagsModel" label-width="100px" :fields="relateTagsModelFields"
                     :btnDoSubmit="relateTagsSubmit" :btnDoCancal="relateTagsCancle" :btnShowReset="false"
                     formName="clear" :pageload="pageloadTree">
                <cl-form-row class="col-24">
                    <RelateTags slot="tags" ref="tags" :requestUrl="requestUrl" :requestParams="requestParams"
                                :selectedData="relateTagsModel.tagsArr" @finalData="finalData" :limit="limit">
                    </RelateTags>
                </cl-form-row>
            </cl-form>
        </el-dialog>

        <!-- 素材库 -->
        <tabBoxs :modelType='modelType' :principalId="principalId"
                 @cancalBtn="cancalBtn" tabTypeShow
                 @beforeClose="beforeClose" v-if="materialOpen" :open="materialOpen"></tabBoxs>
    </div>
</template>

<script>
    import poiForm from '../poi/poiForm';
    import changeOnlineStatus from '../public/changeOnlineStatus.js'

    export default {
        name: 'poiList',
        components: {poiForm},
        data() {
            const _this = this;
            return {
                /** 素材库开始 **/
                modelType: "select",
                principalId: "",
                isScenic: "",
                materialOpen: false,
                /** 素材库结束 **/
                pageUrl: "",
                pageRelUrl: "/wtcp-bics/poi/page",
                //远程搜索组件
                allScenic: [],
                loading: false,
                objid: '',
                resid: '',
                id: -1,
                dialogVisible1: false,
                oprah: {},
                type: '',
                status: '',
                optionss: [
                    {
                        label: '不限',
                        value: -1
                    },
                    {
                        label: '上线',
                        value: 9
                    },
                    {
                        label: '下线',
                        value: 1
                    }],
                poiType: [],
                props: {
                    value: "code",
                    label: "name"
                },
                showPoiType: {},
                selectedDataKeys: [],
                selectedData: [],
                paramsUrl: {
                    principalId: ""
                },
                //快速搜索
                searchRules: {
                    title: this.validate.rules({min: 0, max: 20, validator: 'chinese_english_number_s',}),
                },
                searchDatas: {
                    regionFullCode: "",
                    title: '',
                    principalId: '',
                    status: '',
                    type: ''
                },
                quickSearchKey: "title",
                quickSearchReg: /[%]|[_]|[*]/,
                quickSearchPlaceholder: "请输入标题",
                actionWidth: "120",
                action: [
                    {
                        name: "poi:u",
                        disabled: function (a) {
                            if (a.status == "9") {
                                return true;
                            } else {
                                return false;
                            }
                        },
                        click: function (e) {
                            _this.opt.editRow(e, _this, 'wtcp-bics-poi-edit', {id: e.id});
                        },
                    },
                    {
                        name: 'poi:rt',
                        click: function (e) {
                            _this.relateTagsModal = true;
                            _this.pageloadTree = false;
                            _this.relateTagsModel.id = e.id;
                            _this.showTags(e.id);
                        }
                    },
                    {
                        name: "poi:d",
                        disabled: function (a) {
                            if (a.status == "9") {
                                return true;
                            } else {
                                return false;
                            }
                        },
                        click: function (row, refesh) {
                            _this.opt.deleteRow(
                                row,
                                refesh,
                                "/wtcp-bics/poi/",
                                _this
                            );
                        },
                    },
                    {
                        name: 'material:u',
                        click: function (e) {
                            _this.principalId = e.id;
                            _this.materialOpen = true;
                        }
                    }
                ],
                // 工具栏
                tools: [
                    {
                        name: 'poi:c',  //添加数据按钮
                        click: function () {
                            _this.$router.push({
                                    name: 'wtcp-bics-poi-create',
                                    query: {
                                        id:-1,
                                        principalId: _this.paramsUrl.principalId,
                                        isScenic: _this.isScenic
                                    }
                                });
                        }
                    },
                    {
                        name: "poi:bd",
                        click: function (refesh) {
                            if (_this.selectedDataKeys.length == 0) {
                                _this.$message.error("请先选择要批量删除的数据!");
                            } else {
                                _this.batchPoiDelete(_this.selectedDataKeys, refesh);
                            }
                        },
                    }
                ],
                // 列表数据
                tableHeader: [
                    {
                        type: "check",
                        align: "center",
                    },
                    {
                        type: 'extend',
                        label: '',
                        extend: function (e) {
                            const subTitle = e.subTitle ? e.subTitle : "暂无数据";
                            const longitude = e.longitude ? e.longitude : "暂无数据";
                            const latitude = e.latitude ? e.latitude : "暂无数据";
                            const insideScenic = e.insideScenic ?(e.insideScenic==1?"是":"否") : "暂无数据";
                            return '<div class="extend-box">' +
                                '<span>子标题：' + subTitle + '</span>' +
                                '<span>经度：' + longitude + '</span>' +
                                '<span>纬度：' + latitude + '</span>' +
                                '<span>是否在景区：' + insideScenic + '</span>'+
                                '</div>' ;
                        }
                    },
                    {
                        label: "标题",
                        prop: "title",
                    },
                    {
                        label: "所在地区",
                        prop: "regionFullName",
                        width: "150",
                        formatter: function (params) {
                            let str = params.regionFullName;
                            str = str.replace(/,/g, "");
                            return str;
                        }
                    },
                    {
                        label: "所属景区",
                        prop: "scenicName",
                        width: "150"
                    },
                    {
                        label: "类型",
                        prop: "type",
                        width: "100",
                        formatter: function (params) {
                            return _this.showPoiType[params.type];
                        }
                    },
                    {
                        type: 'switch',
                        label: '状态',
                        align: "center",
                        prop: 'status',
                        activeColor: '#13ce66',
                        inactiveColor: '#dcdfe6',
                        activeText: '上线',
                        inactiveText: '下线',
                        activeValue: 9,
                        inactiveValue: 1,
                        width: "100",
                        auth: "poi:s",
                        change: this.poiStateChange
                    }
                ],
                pageload: true,
                /************关联标签**************/
                requestUrl: "/wtcp-bics/tags/getTagsByKind",
                requestParams: {kind: 9},
                limit: 9,
                relateTagsModal: false,
                relateTagsModel: {
                    id: null,
                    tagsArr: []
                },
                selectedNode: null,
                pageloadTree: true,
                relateTagsModelFields: {
                    row1: [
                        {
                            name: "tags",
                            label: "关联标签",
                            span: 24
                        }
                    ]
                },
                tagSelectFlag: false,
                refreshPage:null,
                classPName:"Poi",
                /***批量上线***/
                th: this,
                auth: {},
                batchAuditModel: {
                    ids: [],
                    batchAuditStatus: 1,
                    batchMsg: "",
                    type:"",//操作类型。0：审核操作  1：上下线操作
                    classPrefixName:_this.classPName,
                    hasAudit:false
                },
            };
        },
        methods: {
            refresh(e){
                this.refreshPage = e;
            },
            tableRefresh(){
                this.selectedDataKeys = [];
            },
            pageChange(e){
                this.selectedDataKeys = [];
            },
            cancalBtn() {
                this.materialOpen = false;
            },
            //关闭弹框
            beforeClose() {
                this.materialOpen = false
            },
            remoteMethod(query) {
                let _this = this;
                _this.allScenic = [];
                if (query !== '') {
                    _this.loading = true;
                    _this.request.get('/wtcp-bics/rpc/scenic/getScenicInfo', {title: query}).then(res => {
                        if (res.status == 1) {
                            _this.allScenic = res.data;
                        }
                        _this.loading = false;
                    })
                } else {
                    _this.allScenic = [];
                }
            },
            clearArray() {
                this.allScenic = [];
            },
            //复选框选择事件
            selectAll(data, attr) {
                let keys = [];
                for (const i in data) {
                    keys.push(data[i].id);
                }
                this.selectedDataKeys = keys;
                this.selectedData = data;
            },
            selectedDatas(data, e) {
                let keys = [];
                for (const i in data) {
                    keys.push(data[i].id);
                }
                this.selectedDataKeys = keys;
                this.selectedData = data;
            },
            //批量删除
            batchPoiDelete(data, refesh) {
                let _this = this;
                for (let i = 0; i < _this.selectedData.length; i++) {
                    if (_this.selectedData[i].status == 9) {
                        _this.$message.error("poi【" + _this.selectedData[i].title + "】不允许删除");
                        return;
                    }
                }
                _this.$confirm("确认要删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        _this.request.put("/wtcp-bics/poi/batchDelete", data).then(res => {
                            if (res.status == 1) {
                                _this.$message.success(res.msg);
                                refesh();
                            } else if (res.status == 0) {
                                _this.$message.error(res.msg);
                            }
                        });
                    })
                    .catch(() => {
                        _this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            areaCodeChange(a, b) {
                let s = "";
                for (let i = 0; i < a.length; i++) {
                    s += a[i] + ",";
                }
                s = s.substring(0, s.length - 1);
                this.searchDatas.regionFullCode = s;
            },
            searchTypeChange(a){
                this.searchDatas.type=a==-1?"":a.length==1?a[0]:a[1];
            },
            //上线
            poiStateChange(value, e, refresh) {
                let that = this;
                let OnlineData = {
                    preStatus: e.status,
                    status: e.status,
                    principalId: e.id,
                };
                that.request.put("/wtcp-bics/poi/issue", OnlineData).then(res => {
                    if (res.status == 1) {
                        that.$message.success(res.msg);
                        that.auditModelSync = false;
                    } else {
                        that.$message.error(res.msg);
                    }
                    // // 刷新列表
                    // refresh();
                    that.pageload = false;
                })
            },
            //获取类型信息
            getPoiType() {
                const _this = this;
                this.request.get('/wtcp-coder/rpc/dict/findByCode', {code: '127'}).then(res => {
                    if (res.status == 1) {
                        let arr=res.data;
                        for (let i = 0; i < arr.length; i++) {
                                _this.showPoiType[arr[i].code] = arr[i].name;
                        }
                        _this.poiType = arr;
                        _this.poiType.unshift({
                            code: '-1',
                            name: '不限'
                        })
                        _this.pageUrl = _this.pageRelUrl;
                        _this.pageload = false;
                    }
                })
            },
            closeRelateTagsModal() {
                this.relateTagsModal = false;
            },
            relateTagsSubmit() {
                let _this = this;
                if (_this.relateTagsModel.tagsArr.length == 0) {
                    this.$message.error("请选择关联标签");
                } else {
                    let list = [];
                    for (let i = 0; i < _this.relateTagsModel.tagsArr.length; i++) {
                        let n = {
                            principalId: _this.relateTagsModel.id,
                            tagCatagory: _this.relateTagsModel.tagsArr[i].pName,
                            tagName: _this.relateTagsModel.tagsArr[i].name
                        };
                        list.push(n);
                    }
                    _this.relateTagsModel.tagsArr = list;
                    _this.request.put("/wtcp-bics/poi/relateTags", _this.relateTagsModel).then(res => {
                        if (res.status === 1) {
                            _this.$message.success("关联标签成功");
                        } else {
                            _this.$message.error(res.msg);
                        }
                        _this.relateTagsModal = false;
                    });
                }
            },
            relateTagsCancle() {
                this.relateTagsModal = false;
            },
            finalData(data) {
                this.relateTagsModel.tagsArr = data;
            },
            showTags(id) {
                this.pageload = true;
                const _this = this;
                this.request.get('/wtcp-bics/tags/findPoiByPid', {principalId: id}).then(res => {
                    if (res.status == 1) {
                        let arr = [];
                        for (let i in res.data) {
                            arr.push({name: res.data[i].tagName, pName: res.data[i].tagCatagory});
                        }
                        _this.relateTagsModel.tagsArr = arr;
                    } else {
                        _this.relateTagsModel.tagsArr = new Array();
                    }
                    _this.pageload = false;
                })
            },
            /*******中间搜索start**********/
            poiTypeChange(val) {
                this.paramsUrl = {
                    type: val.length==0 || val[0] == "-1"?"":val[val.length-1],
                    status: this.status == -1 ? '' : this.status
                }
            },
            statusChange(val) {
                this.paramsUrl = {
                    status: val,
                    type: this.type.length == 0 || this.type[0] == "-1"? '' : this.type[this.type.length-1]
                }
            },
            /***批量上线****/
            handleCommand(command){
                this.batchAuditModel.classPrefixName=this.classPName;
                this.batchAuditModel.hasAudit=false;
                changeOnlineStatus(command, this);
            },
        },

        created: function () {
            this.getPoiType();
            this.isScenic = this.$route.query.isScenic ? this.$route.query.isScenic : "";
            if (this.isScenic == -2) {
                this.paramsUrl.principalId = this.$route.query.principalId ? this.$route.query.principalId : "";
            }
            this.request.oprahfun(this);
            this.request.getAuth(this);
        },
        computed: {
            show() {
                return this.dialogVisible
            }
        }
    };
</script>
<style lang="less">
    .poiList {
        .extend-box {
            height: 35px;
            line-height: 35px;

            span {
                margin-left: 30px;
                display: inline-block;
                width: 20%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .poiSearch {
            .el-input__inner ,.el-cascader,.el-input__icon{
                height: 32px;
                line-height: 31px;
            }
        }
        .searchSelect {
            .el-input {
                width: 200px;
            }
        }

        .selectItem {
            margin-right: 8px;

            .el-input {
                width: 100% !important;
            }
        }
        .glbqButton {
            float: right;
            .el-button{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-left-color: rgba(255,255,255,.5);
            }
        }
        .el-button-group .el-button:nth-last-child(1){
            border-radius: 0;
        }
    }

    .vue-treeselect--has-value .vue-treeselect__multi-value {
        margin-bottom: 0px;
    }

    .el-popper.el-cascader__dropdown {
        z-index: 2100 !important;
    }
</style>




